import { Injectable } from '@angular/core';
// import * as fileSaver from 'file-saver';
import { saveAs } from 'file-saver-es';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';

@Injectable({
    providedIn : 'root'
})
export class ExcelService {
    
    constructor() { }

    public exportAsExcelFile(json: any[], excelFileName: string, strictFileNameOnly: boolean = false): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName, strictFileNameOnly);
    }
    private saveAsExcelFile(buffer: any, fileName: string, strictFileNameOnly: boolean = false): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        const finalFileName = strictFileNameOnly ? `${fileName}${EXCEL_EXTENSION}` : `${fileName}_${new Date().getTime()}${EXCEL_EXTENSION}`;
        saveAs(data, finalFileName);
    }

    // Export JSON data as CSV
    public exportAsCSVFile(json: any[], fileName: string, strictFileNameOnly: boolean = false): void {
        const csvContent = this.convertToCSV(json);
        const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const finalFileName = strictFileNameOnly ? `${fileName}${CSV_EXTENSION}` : `${fileName}_${new Date().getTime()}${CSV_EXTENSION}`;
        saveAs(data, finalFileName);
    }

    // Convert JSON to CSV format
    private convertToCSV(objArray: any[]): string {
        if (!objArray || objArray.length === 0) return '';
    
        const keys = Object.keys(objArray[0]);
    
        // Convert each row into CSV format
        const csvRows = objArray.map(row => 
            keys.map(key => {
                let value = row[key] ?? ''; // Handle null/undefined values
                return `"${String(value).replace(/"/g, '""')}"`; // Escape double quotes
            }).join(",")
        );
    
        // Add headers
        return `\ufeff${keys.join(",")}\n${csvRows.join("\n")}`;
    }
    
}